export default __webpack_public_path__ + "static/media/toon_lizzie.ee694c1f.png";